window.addEventListener('load', () => {
  window.dataLayer = window.dataLayer || []

  // Account Register
  const registerSuccessEl = document.querySelector(
    '[data-event-register-success]'
  )
  if (registerSuccessEl) {
    window.dataLayer.push({
      event: 'account_register',
      account_id: registerSuccessEl.dataset?.eventRegisterSuccess,
    })
  }

  // Account Login
  const accountSectionEl = document.querySelector('[data-event-account-login]')
  if (accountSectionEl) {
    window.dataLayer.push({
      event: 'user_login',
      account_id: accountSectionEl.dataset?.eventAccountLogin,
    })
  }

  // Mega menu links
  const navLinks = document.querySelectorAll('[data-event-nav-link]')
  navLinks.forEach((link) => {
    link.addEventListener('click', (e) => {
      const linkLabel = e.target.innerText
      const linkSection = e.target.dataset?.navCategory || ''

      window.dataLayer.push({
        event: 'menu_selection',
        filter_name: linkSection,
        filter_selection: linkLabel,
      })
    })
  })

  // PLP Filter
  const plpFilterForm = document.querySelector('.js-filter-form-event')
  plpFilterForm?.addEventListener('change', (e) => {
    const filterWrapper = e.target.closest('[data-filter-wrapper]')
    const filterLabel = filterWrapper.querySelector(
      '[data-filter-label]'
    )?.innerText
    const filterValue = e.target.value

    window.dataLayer.push({
      event: 'filter_tracking',
      filter_name: filterLabel,
      filter_selection: filterValue,
    })
  })

  // Country Selector
  const selectCountryForm = document.getElementById('md-modal__form__id')
  const selectCountryButton = document.getElementById('md-btn__form__onSubmit')
  const selectCountryListItem = document.querySelectorAll(
    '.md-form__select__country__list > li'
  )

  selectCountryListItem.forEach((el) => {
    el.addEventListener('click', () => {
      const btn = selectCountryForm.querySelector(
        '#md-form__select__country'
      )

      setTimeout(() => {
        window.dataLayer.push({
          event: 'country_select',
          country_name: btn.dataset?.value,
        })
      }, 0)
    })
  })

  !!selectCountryButton && selectCountryButton.addEventListener('click', (e) => {
    e.preventDefault()
    const data = new FormData(selectCountryForm)
    
    window.dataLayer.push({
      event: 'shipping_country_confirmed',
      country_name: data?.get('country_code'),
    })
  })

  // Index page CTA
  const sectionCtaEls = document.querySelectorAll('[data-event-section-cta]')
  sectionCtaEls.forEach((el) => {
    el.addEventListener('click', (e) => {
      const target = e.target
      const fallback = e.currentTarget

      const ctaButton =
        target?.dataset?.eventSectionCta || target?.dataset?.eventCtaName
          ? target
          : fallback
      
      const ctaSection = e.target.closest('[data-event-section-name]')

      window.dataLayer.push({
        event: 'cta_click',
        button_name: ctaButton.dataset?.eventSectionCta,
        cta_name: ctaButton.dataset?.eventCtaName,
        page_position: ctaSection.dataset?.eventSectionName,
      })
    })
  })
})

/* Accessibility */
function waitForElement(selector) {
  return new Promise(resolve => {
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector))
    }

    const observer = new MutationObserver(mutations => {
      if (document.querySelector(selector)) {
        observer.disconnect()
        resolve(document.querySelector(selector))
      }
    })

    observer.observe(document.body, {
      childList: true,
      subtree: true
    })
  })
}

// Yotpo - PDP Widget
waitForElement('.yotpo-main-widget').then((wrapper) => {
  wrapper.addEventListener('click', (e) => {
    const summary = e.target.closest('#yotpo-summary')
    if (summary) {
      window.dataLayer.push({
        event: 'reviews_summary_click',
        button_name: 'Reviews Summary',
      })
    }

    const filter = e.target.closest('.yotpo-summary-topic.yotpo-summary-filter')
    if (filter) {
      window.dataLayer.push({
        event: 'reviews_summary_filter_click',
        filter_selection: filter.innerText?.trim() || 'Unknown',
      })
    }

    const smart = e.target.closest('.yotpo-smart-topic-filter.smart-topic-wrapper')
    if (smart) {
      window.dataLayer.push({
        event: 'reviews_smart_filter_click',
        filter_selection: smart.innerText?.trim() || 'Unknown',
      })
    }
  })
})

waitForElement('img[id^="batBeacon"]').then((element) => {
  element.setAttribute('alt', 'Bat Beacon')
  element.setAttribute('title', 'Bat Beacon')
})

waitForElement('#onetrust-consent-sdk .ot-pc-logo img').then((element) => {
  const alt = element.getAttribute('alt')
  element.setAttribute('title', alt)
})

waitForElement('#onetrust-consent-sdk').then((element) => {
  const target = element.querySelector('#onetrust-banner-sdk')
  if (!target) {
    return
  }

  const observer = new IntersectionObserver(([entry]) => {
    if (entry.intersectionRatio) {
      document.body.classList.add('onetrust-consent-opened')
    } else {
      document.body.classList.remove('onetrust-consent-opened')
    }
  })

  observer.observe(target)
})
